import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";
import AuthReadyGuard from "../common/AuthReadyGuard";

const SellerGuard = ({ children }) => {
  const { user, authReady, refreshUser } = useAuth();
  const [allowSeller, setAllowSeller] = useState(null);

  useEffect(() => {
    if (!authReady) return undefined;

    let cancelled = false;

    const verifySellerAccess = async () => {
      if (user?.roles?.includes("seller")) {
        if (!cancelled) setAllowSeller(true);
        return;
      }

      // Profile may be stale after first draft/listing — refresh once before redirecting.
      const profile = await refreshUser();
      if (!cancelled) {
        setAllowSeller(Boolean(profile?.roles?.includes("seller")));
      }
    };

    verifySellerAccess().catch(() => {
      if (!cancelled) setAllowSeller(false);
    });

    return () => {
      cancelled = true;
    };
  }, [authReady, refreshUser, user?.roles]);

  if (!authReady || allowSeller === null) {
    return <AuthReadyGuard isPending />;
  }

  if (!allowSeller) {
    return <Navigate to="/seller/listings/add" replace />;
  }

  return children ? children : <Outlet />;
};

export default SellerGuard;
